<div class="" *ngIf="!!form">
  <p><span class="paragraph-medium-regular">Parent document:</span><span class="paragraph-medium-bold">{{
      parentDocumentNo }}</span></p>
  <app-read-only-table [data]="childDocArray"
    [columns]="displayedColumns"></app-read-only-table>
</div>


<div class="reference" *ngIf="!isrfsDoc">
  <mat-accordion multi="true">
    <mat-expansion-panel hideToggle="true" #panel [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-title class="title">
          <mat-icon class="expansion-arrow">{{
            panel.expanded ? "arrow_drop_up" : "arrow_drop_down"
            }}</mat-icon>
          <div>Downstream documents</div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="table-title paragraph-medium-regular">
        <span>Upon approval completion of this document, related downstream documents will be
          updated accordingly.</span>
      </div>
      <div *ngIf="(purchaseType === 'rfq' || purchaseType === 'corporatecard' || purchaseType === 'permissiblecoveringpurchaseorder')">
        <div *ngIf="evaluationReportRef.length > 0">
          <div class="table-title paragraph-medium-regular">
            <span>Evaluation Report: </span>
            <span *ngFor="let document of evaluationReportRef; let i = index">
              <a (click)="redirectMMS(document.DocumentEntityName, document.DocumentID)">{{document.DocumentNumber}}
              </a> <span *ngIf="i !== evaluationReportRef.length - 1">, </span></span>
          </div>
        </div>
        <div class="table-title paragraph-medium-regular" *ngIf="(evaluationReportRef.length == 0)">
          <span>Evaluation Report: </span> -
        </div>
        <div *ngIf="purchaseOrderRef.length > 0">
          <div class="table-title paragraph-medium-regular">
            <span>Purchase order: </span>
            <span *ngFor="let document of purchaseOrderRef; let i = index">
              <a (click)="redirectMMS(document.DocumentEntityName, document.DocumentID)">{{document.DocumentNumber}}
              </a> <span *ngIf="i !== purchaseOrderRef.length - 1">, </span></span>
          </div>
        </div>
        <div class="table-title paragraph-medium-regular" *ngIf="(purchaseOrderRef.length == 0)">
          <span>Purchase order: </span> -
        </div>
      </div>


      <div *ngIf="(purchaseType === 'tender' || purchaseType === 'dc')">
        <div *ngIf="contractReportRef.length > 0">
          <div class="table-title paragraph-medium-regular">
            <span>Contracts : </span>
            <span *ngFor="let document of contractReportRef; let i = index">
              <a (click)="redirectMMS(document.DocumentEntityName, document.DocumentID)">{{document.DocumentNumber}}
              </a> <span *ngIf="i !== contractReportRef.length - 1">, </span></span>
          </div>
        </div>
        <div class="table-title paragraph-medium-regular" *ngIf="(contractReportRef.length == 0)">
          <span>Contracts: </span> -
        </div>

      </div>



    </mat-expansion-panel>
  </mat-accordion>


</div>


<div *ngIf="isrfsDoc">
  <div class="sub-header paragraph-medium-regular">
    <span>Upon approval completion of this document, related downstream documents will be
      updated accordingly.</span>
  </div>
  <app-loader [isLoading]="isLoading"></app-loader>
  <ng-container *ngIf="!isLoading">
    <app-add-reference-card [desc]="'You have no records available.'" *ngIf="RFQReferencedataSource.data.length < 1">
    </app-add-reference-card>
    <div class="scrollmenu">
      <table mat-table [dataSource]="RFQReferencedataSource" class="mat-elevation-z8 data-grid-table"
        *ngIf="RFQReferencedataSource.data.length > 0">

        <!-- RFQNumber Column -->
        <ng-container matColumnDef="rfqNumber">
          <th mat-header-cell *matHeaderCellDef>Request for Quotation no.</th>
          <td mat-cell *matCellDef="let row"><span class="link" (click)="onRFQNumberClick(row)">{{row.RFQNumber }}</span></td>
        </ng-container>

        <!-- Document Number Column -->
        <ng-container matColumnDef="documentNumber">
          <th mat-header-cell *matHeaderCellDef>RFQ Summary Doc / Evaluation Report no.</th>
          <td mat-cell *matCellDef="let row">
            <ng-container *ngIf="!row.groupedSummary; else clickableText">
              <span class="sub-text">Not yet created</span>
            </ng-container>
            <ng-template #clickableText>
              <span *ngFor="let summaryDoc of row.groupedSummary.split(','); let last = last" class="link"
                (click)="onSummaryDocClick(summaryDoc.trim())">
                {{ summaryDoc.trim() }}
                <span *ngIf="!last">, </span> <!-- Add a comma separator between PO numbers -->
              </span>
            </ng-template>
          </td>
        </ng-container>

        <!-- PO Number Column -->
        <ng-container matColumnDef="poNumber">
          <th mat-header-cell *matHeaderCellDef>Purchase Order no.</th>
          <td mat-cell *matCellDef="let row">
            <ng-container *ngIf="!row.podocs || row.podocs === 'Not yet created'; else clickableText">
              <span class="sub-text">Not yet created</span>
            </ng-container>
            <ng-template #clickableText>
              <span *ngFor="let po of row.podocs.split(','); let last = last" class="link"
                (click)="onPONumberClick(po.trim())">
                {{ po.trim() }}
                <span *ngIf="!last">, </span> <!-- Add a comma separator between PO numbers -->
              </span> </ng-template>
          </td>
        </ng-container>

        <!-- Table Header Row -->
        <tr mat-header-row *matHeaderRowDef="displayedRFQColumns"></tr>

        <!-- Table Data Row -->
        <tr mat-row *matRowDef="let row; columns: displayedRFQColumns;"></tr>
      </table>

    </div>
    <mat-paginator [ngClass]="{'d-none': RFQReferencedataSource.data.length < 1}"
      [length]="RFQReferencedataSource.data.length" [pageSize]="5" [pageSizeOptions]="[5, 10, 25, 50]"
      showFirstLastButtons>
    </mat-paginator>
  </ng-container>
</div>